import React, { useEffect, useRef, useState } from "react";
import { motion } from "framer-motion";
import { LOGO } from "../../../../assets";

const textAnimation = {
  hidden: { opacity: 0, y: -100 },
  visible: { opacity: 1, y: 0 },
};

const logoAnimation = {
  hidden: { opacity: 0, y: 0 },
  visible: { opacity: 1, x: 0 },
};
const text2Animation = {
  hidden: { opacity: 0, x: 100 },
  visible: { opacity: 1, x: 0 },
};

export default function Welcome() {
  const [isVisible, setIsVisible] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        setIsVisible(entry.isIntersecting);
      },
      { threshold: 0.1 }
    );

    if (ref.current) {
      observer.observe(ref.current);
    }

    return () => {
      if (ref.current) {
        observer.unobserve(ref.current);
      }
    };
  }, []);

  return (
    <div className="bg-white h-auto flex justify-center items-center px-5 lg:py-[100px] md:py-15 py-10 overflow-hidden font-poppins tracking-wider">
      {/* // <div className=' 2xl:bg-red xl:bg-yellow lg:bg-hero md:bg-green bg-blue h-auto flex justify-center items-center px-5 py-[100px] overflow-hidden'> */}
      <div className="max-w-screen-2xl w-full h-full grid 2xl:grid-cols-9 lg:grid-cols-8 grid-cols-1">
        <div
          className="flex flex-col items-start md:items-center lg:items-start col-span-6 lg:col-span-2 2xl:col-span-2 bg-"
       
        >
          <div className="flex 2xl:mt-[-5%]">
            <p className="lg:text-[60px] md:text-[50px] text-[40px] font-extralight text-secondary">
              Welcome{" "}
            </p>
          </div>
          <div className="flex items-center 2xl:mt-[-10%] lg:mt-[-12%] md:mt-[-5%] mt-[-10%] pt-4">
            <p className="lg:text-[60px] md:text-[50px] text-[40px] font-extralight text-center text-secondary">
              to
            </p>
            <img
              src={LOGO.BLACK}
              alt="black logo"
              className=" lg:h-[45px] md:h-[35px] h-[28px] mt-6 pl-4 mb-5 md:mb-0"
          
            />
          </div>
        </div>
        <div className="flex flex-col lg:flex-row justify-center items-center col-span-4 lg:col-span-6 2xl:col-span-7">
          <div
           
            className="flex flex-col lg:flex-row items-center lg:items-start w-full text-center lg:text-start text-secondary font-poppins"
          >
            <div className="bg-gray hidden md:block w-[100px] h-[2px] lg:w-[2px] lg:h-[75px] mb-5 lg:ml-12 lg:mr-10 "></div>
            <div className="tracking-widest lg:text-[17px] md:text-base text-[15px] text-start">
              <p>
                All are embraced at Grow, your premier destination for dental
                care in Kuwait City. Our approach is rooted in a philosophy of
                zero judgment and no pressure.
              </p>
              <p className="mt-[2%]">
                Founded by Dr. Salem Al Qabandi and his partners, our clinic,
                formerly known as Taqweem, has grown into a premier dental
                destination in Kuwait. With a focus on progress over results, we
                invest in overall self-care, ensuring that your oral health is a
                key part of your wellness journey. Located in the spacious Kipco
                Tower, our expanded team of top-notch doctors is here to provide
                an elevated treatment experience. At Grow Clinic, we aim to
                change the conversation around oral hygiene and offer a fresh,
                honest perspective on prevention and care for generations to
                come. Join us in redefining what to expect from an oral health
                clinic.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
